import { BetrokkenStationsDto } from "@/shared/types";
import { BetrokkenStationsBetrokkenheid, betrokkenStationsBetrokkenheidFilters } from "./constants";

export interface BetrokkenStation {
    id: number;
    stationsCode: string;
    betrokkenheid: BetrokkenStationsBetrokkenheid[];
}

export const BetrokkenStation = {
    fromDto: (dto: BetrokkenStationsDto): BetrokkenStation => ({
        id: dto.id,
        stationsCode: dto.stationsCode,
        betrokkenheid: dto.betrokkenheid satisfies BetrokkenStationsBetrokkenheid[],
    }),

    filterForType: (filterFor: keyof typeof betrokkenStationsBetrokkenheidFilters) => (betrokkenStations: BetrokkenStation[]) => {
        return betrokkenStations.filter((bs) =>
            bs.betrokkenheid.some((betrokkenheid) => betrokkenStationsBetrokkenheidFilters[filterFor].includes(betrokkenheid))
        );
    },
};
